import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LeadHistoryPanelComponent } from "./lead-history-panel.component";

import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { RouterModule } from "@angular/router";
import { MatRippleModule } from "@angular/material/core";

@NgModule({
    declarations: [LeadHistoryPanelComponent],
    imports: [
        CommonModule,
        MatListModule,
        MatProgressBarModule,
        RouterModule,
        MatRippleModule,
    ],
})
export class LeadHistoryPanelModule {}
